import {
  DEFAULT_RESOLUTION_BANNER_ACCEPT_LABEL,
  DEFAULT_RESOLUTION_BANNER_MESSAGE,
  DEFAULT_RESOLUTION_BANNER_REJECT_LABEL,
} from '../constants/labels';

export type CaseResolutionBannerProps = {
  readonly message?: string
  readonly rejectLabel?: string
  readonly acceptLabel?: string
  readonly acceptDisabled?: boolean
  readonly onReject: () => void
  readonly onAccept: () => void
  readonly canViewCaseResolution: boolean
}

export default function CaseResolutionBanner({
  message = DEFAULT_RESOLUTION_BANNER_MESSAGE,
  rejectLabel = DEFAULT_RESOLUTION_BANNER_REJECT_LABEL,
  acceptLabel = DEFAULT_RESOLUTION_BANNER_ACCEPT_LABEL,
  acceptDisabled,
  onReject,
  onAccept,
                                               canViewCaseResolution,
}: CaseResolutionBannerProps) {
  return (
    <>
      {canViewCaseResolution && (
        <div className="cop-case-details__resolution-banner">
          <p className="cop-case-details__resolution-banner__message">{message}</p>
          <div className="cop-case-details__resolution-banner__actions">
            <button
              type="button"
              className="cop-case-details__resolution-btn cop-case-details__resolution-btn--accept"
              onClick={onAccept}
              disabled={acceptDisabled}
            >
              {acceptLabel}
            </button>
            <button
              type="button"
              className="cop-case-details__resolution-btn cop-case-details__resolution-btn--reject"
              onClick={onReject}
            >
              {rejectLabel}
            </button>
          </div>
        </div>
      )}
    </>
  );
}
